import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastTypeEnum } from './toast-type-enum';
import { ToastService } from './service/toast.service';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class ToastComponent {
  private toastService = inject(ToastService);
  toastConfig$ = this.toastService.toastConfig$;
  readonly defaultDurationMs = 5000;

  iconList: Record<ToastTypeEnum, string> = {
    [ToastTypeEnum.INFO]: 'pi-info-circle',
    [ToastTypeEnum.SECURE]: 'pi-shield',
    [ToastTypeEnum.WARNING]: 'pi-exclamation-circle',
    [ToastTypeEnum.ERROR]: 'pi-times',
    [ToastTypeEnum.SUCCESS]: 'pi-check-circle'
  };

  close() {
    this.toastService.setToast(null);
  }
}
